import OapCardPopin from './code/Scripts/components/OapCardPopin.vue';

export default {
  components: {
    OapCardPopin,
  },
};
